import _ from 'lodash'
import Vue from 'vue'
export default {
  data () {
    return {
      alerta: {
        mostrar: false,
        mensaje: null,
        tipo: 'error'
      }
    }
  },
  methods: {
    mostrarError (error, notificacion) {
      if (notificacion) {
        this.mostrarNotificacion(error.message, 'error')
      } else {
        this.alerta = {
          mostrar: true,
          mensaje: error.message,
          tipo: 'error'
        }
      }
    },
    mostrarExito (mensaje) {
      this.alerta = {
        mostrar: true,
        mensaje: mensaje,
        tipo: 'success'
      }
    },
    ocultarAlerta () {
      this.alerta = {
        mostrar: false,
        mensaje: null
      }
    },
    mostrarErroresEnCampos (error) {
      let vm = this
      this.alerta = {
        mostrar: true,
        mensaje: 'Ocurrieron los siguientes errores:',
        tipo: 'error'
      }
      if (error.fields && vm.errors) {
        vm.errors.clear()
        _.forEach(error.fields, function (value, key) {
          vm.errors.add({ field: key, msg: value[0] })
        })
      }
    },
    mostrarNotificacion (mensaje, tipo) {
      let _tipo = tipo || 'success'
      Vue.notify({
        group: 'general',
        type: _tipo,
        text: mensaje
      })
    }
  }
}
